import { useMutation } from "@tanstack/react-query";
import { AuthAPI } from "../api";
import Cookies from "js-cookie";

export const useValidateClient = () => {
  return useMutation({
    mutationFn: () => AuthAPI.validateClient(),
    onSuccess: (data) => {
      const expiresInHours = 5 / 24; // 5 hours
      Cookies.set("clientToken", data.data.accessToken, {
        expires: expiresInHours,
        // secure: true,
      });
      Cookies.set("clientRefreshToken", data.data.refreshToken, {
        expires: expiresInHours,
        // secure: true,
      });
    },
  });
};

export const useAuthUser = () => {
  return useMutation({
    mutationFn: ({ email, password }) => AuthAPI.authUser(email, password),
    onSuccess: (data) => {
      const expiresInHours = 5 / 24; // 5 hours
      Cookies.set("webapitoken", data.data.token, {
        expires: expiresInHours,
        // secure: true,
      });
    },
    onError: (error) => {
      console.error("Login Failed: ", error.response || error);
    },
  });
};
